import * as React from "react";


import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {FBButtonSelectionOptions} from "./FBButtonSelection.options";
import {OptionsCalculator} from "FormBuilder/Core/Calulators/OptionsCalculator";
import {FBMultipleOptionsBaseModel} from "FormBuilder/Fields/Core/FBMultipleOptionsBase.Model";

export class FBButtonSelectionModel extends FBMultipleOptionsBaseModel<FBButtonSelectionOptions,FBColumnModel>
{
    SelectedValues:any[];
    constructor(Options: FBButtonSelectionOptions, Parent: FBColumnModel) {
        super(Options, Parent);
    }


    get AllowMultiple(): boolean {
        return this.Options?.AllowMultipleSelection;
    }

    GetDynamicFieldNames(): string[] {
        return ['FBButtonSelection'];
    }
}